import {GetPreRegisterConsultParams, GetPreRegisterConsultResponse} from 'domain/usecases/others/facial-biometric';
import {makeGetRequestFacialBiometricPreRegisterConsult} from 'main/factories/usecases/others/facial-biometric/request/get-pre-register-consult';

export const getPreRegisterConsult = async (
	params: GetPreRegisterConsultParams,
): Promise<GetPreRegisterConsultResponse> => {
	const response = await makeGetRequestFacialBiometricPreRegisterConsult().get(params);
	return response;
};
